var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2203 6.30913L21.6913 8.77897M20.8093 4.1333L14.1278 10.8148C13.7826 11.1595 13.5471 11.5988 13.4512 12.0771L12.834 15.1665L15.9233 14.5481C16.4017 14.4525 16.8403 14.218 17.1857 13.8726L23.8672 7.19113C24.0679 6.99035 24.2272 6.75199 24.3359 6.48966C24.4445 6.22733 24.5005 5.94616 24.5005 5.66222C24.5005 5.37827 24.4445 5.0971 24.3359 4.83477C24.2272 4.57244 24.0679 4.33408 23.8672 4.1333C23.6664 3.93252 23.428 3.77325 23.1657 3.66459C22.9034 3.55593 22.6222 3.5 22.3382 3.5C22.0543 3.5 21.7731 3.55593 21.5108 3.66459C21.2485 3.77325 21.0101 3.93252 20.8093 4.1333Z",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.167 17.5V21C22.167 21.6188 21.9212 22.2123 21.4836 22.6499C21.046 23.0875 20.4525 23.3333 19.8337 23.3333H7.00033C6.38149 23.3333 5.78799 23.0875 5.35041 22.6499C4.91282 22.2123 4.66699 21.6188 4.66699 21V8.16665C4.66699 7.54781 4.91282 6.95432 5.35041 6.51673C5.78799 6.07915 6.38149 5.83331 7.00033 5.83331H10.5003",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.7509e6fc303854018fb7c4161f5700f7.svg";
export { ForwardRef as ReactComponent };